module.exports = __webpack_public_path__ + "img/shopIcon8.1d397010.png";